module.exports = __webpack_public_path__ + "img/sami-halim-jungle.1e4dd6c.jpg";